import { DocumentUploadStatus } from '../constants/document-upload-status.type';
import { UploadMaterialMetadataModel } from './document-metadata.model';

export class DocumentUploadModel {
  public documentId: string = '';
  public materialTypeId?: string;
  public filedDate: Date;
  public uploadProgress: number;
  public uploadStatus: DocumentUploadStatus;
  public document: UploadMaterialMetadataModel = new UploadMaterialMetadataModel();

  constructor(init?: Partial<DocumentUploadModel>) {
    Object.assign(this, init);
  }
}
